
import { commonInputAttrs } from './shared'
import useTracking from '~/composable/tracking/useTracking';

export default {
  props: {
    label: {
      type: String,
      default: '',
      required: true
    },
    requiredText: {
      type: String,
      default: ''
    }
  },
  setup(props) {
    const { trackFieldRule, trackFieldError } = useTracking()

    const requiredRules = [
      v => !!v || trackFieldRule({ message: props.requiredText || 'Du skal skrive ' + props.label.toLowerCase() })
    ]
    return {
      trackFieldError,
      commonInputAttrs,
      requiredRules
    }
  }
}
